import { AxiosResponseHeaders } from 'axios';
import { GenericObject } from '@dxb-web-ui-framework/common/types';

const standingOrdersCancelDTOToStandingOrdersCancelAdapter = (data: GenericObject, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { standingOrdersCancelDTOToStandingOrdersCancelAdapter };
